import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { IconButton, Dialog } from "@mui/material";
import CloseIcon  from "../icon/close-icon";
import ChevronLeftIcon  from "../icon/arrow-left-icon";
import { ButtonComponent } from "./button";

type DialogBoxProps = {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  style?: object;
  title?: string;
  buttonText?: string;
  secondarybuttonText?: string;
  buttonIcon?: any;
  buttonVariant?: string;
  arrowLeftIcon?: boolean;
  isBtnEnabled?:boolean;
  onClickBack?: () => void;
  secondaryButtonClick?: () => void;
  buttonClick?: () => void;
  isLoading?:boolean;
  disabled?: boolean;
  secondaryButtonEnabled?: boolean;
  className?: string;
  buttonAriaLabel?: string;         
  secondaryButtonAriaLabel?: string;
};

export function DialogBox(props: DialogBoxProps): JSX.Element {
  const {
    children,
    arrowLeftIcon,
    onClickBack,
    open,
    onClose,
    style,
    title,
    buttonText,
    secondarybuttonText,
    buttonClick,
    secondaryButtonClick,
    buttonIcon,
    buttonVariant,
    isBtnEnabled,
    disabled,
    isLoading,
    secondaryButtonEnabled,
    className,
  } = props;
  return (
    <Dialog
      open={open}
      fullWidth
      sx={style}
      disableRestoreFocus
      data-testid={`ssarchive-${title}-box`}
      className={className}
      
    >
      <DialogTitle>
        {arrowLeftIcon ? (
          <IconButton sx={{ p: 0, mr: 2 }} onClick={onClickBack}>
            {" "}
            <ChevronLeftIcon />
          </IconButton>
        ) : null}
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
        onClick={() => onClose()}
      >
        <CloseIcon />
      </IconButton>
      {children}
      <DialogActions sx={{ p: 3, justifyContent: secondarybuttonText? 'space-between': ''}}>
        {secondarybuttonText? ( <ButtonComponent
          onClickHandle={secondaryButtonClick}
          buttonName={secondarybuttonText}
          isBtnEnabled={secondaryButtonEnabled}
          color="secondary"
          variant="text"
          buttonIcon={buttonIcon}
          style={{'svg': {width: 16}}}
          ariaLabel={props.secondaryButtonAriaLabel || secondarybuttonText}
        />) : ''}
        {(buttonText) ? 
         <ButtonComponent
         onClickHandle={buttonClick}
         buttonName={buttonText}
         color="primary"
         variant="contained"
         isBtnEnabled={isBtnEnabled}
         disabled={disabled}
         isLoading={isLoading}
         ariaLabel={props.buttonAriaLabel || buttonText}
       /> : ''}

      </DialogActions>

    </Dialog>
  );
}
